import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { ToastrService } from 'ngx-toastr';
import { CreateNewPasswordFromLinkDto } from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
declare let $: any;
import * as CryptoJS from 'crypto-js';
declare let require: any;
let randomize = require('randomatic');
@Component({
  selector: 'app-create-password',
  templateUrl: './create-password.component.html',
})
export class CreatePasswordComponent implements OnInit {
  @ViewChild("testInput") testInput: any;
  erroMessage: any;
  isProducyKeyVerified: boolean = false;
  emailVerified: boolean = false;
  isSubmitted = false;
  otpValue: string = "";
  pwdNotMatch: boolean = false;
  password: any;
  newPassword: boolean = false;
  confPassword: boolean = false;
  currentLanguage: any = 'en';
  browserLang: any;
  languageCode = 'en';
  getEmail: any;
  getName: any;
  verifiedId: any;
  verifyEmailErrorMessage: any;
  getLimitandLink: any;
  passwords: any = 'password';
  language: any;
  createNewPasswordFromLinkDto: CreateNewPasswordFromLinkDto = new CreateNewPasswordFromLinkDto()
  createPwdForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    email: new FormControl(''),
    productKey: new FormControl(''),
    mobileNo: new FormControl(''),
    password: new FormControl(''),
    confirmPassword: new FormControl(''),
    acceptTerms: new FormControl(''),

  });
  @Output() getLimit = new EventEmitter()
  salt: any;
  iv: any;
  passPhrase: any;
  randomUid: any;
  fullWidthDiv: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private _service: ApiService, private _router: Router, public translate: TranslateService,
    private _toastr: ToastrService, private activateRout: ActivatedRoute, private commonService: CommonService,
    private encrypt: EncryptionService) {
    this.iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    this.salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    this.passPhrase = randomize('0', 16);
  }
  link: any
  ngOnInit(): void {
    localStorage.clear();
    this.language = localStorage.getItem('selectedLang');
    const langPref = this.activateRout.snapshot.queryParams['langPref'];
    this.language = this._service.getLanguageMap[langPref] || 'en';
    this.translate.use(this.language);

    if (!this.language || this.language == 'en') {
      this.fullWidthDiv = true;
    } else {
      this.fullWidthDiv = false;
    }
    this.link = this.activateRout.snapshot.queryParams["link"];
    this.getVerifyLinkforEmailSignup();
    this.password = CommonEnums.password;
    this.createPwdForm = this.formBuilder.group(
      {
        password: ['', [RxwebValidators.password({
          validation: {
            upperCase: true,
            lowerCase: true,
            specialCharacter: true
          }
        }), RxwebValidators.minLength({ value: 8 }),
        RxwebValidators.maxLength({ value: 30 })]],
        confirmPassword: ['', Validators.required],

        acceptTerms: [false, Validators.requiredTrue],
      },
    );
    setTimeout(() => {
      this.testInput.nativeElement.focus();
    }, 1000);
    this.getRandaomUID();
  }

  //  Fetching the randon UID here for the request 
  getRandaomUID() {
    this._service.getService(this._service.API_URL.getRandaomUID).subscribe((response) => {
      if (response && response.status.code === 200) {
        this.randomUid = response.data.randomUid;
        localStorage.setItem("random", response.data.randomUid);
        this.saveAESKey()
      }

    })
  }

  //  Saving the keys like salt and passphrase keys
  saveAESKey() {
    let data = {
      secretKey: this.salt,
      iv: this.iv,
      passPhrase: this.passPhrase
    }
    this._service.postService(this._service.API_URL.saveAESKey, data).subscribe((response) => {
      if (response && response.status.code === 200) {
        let genKey = this.encrypt.generateKey(this.salt, this.passPhrase);
        localStorage.setItem('identificationNo', JSON.stringify(genKey));
        localStorage.setItem('iv', this.iv);
      }
    })
  }




  get f(): { [key: string]: AbstractControl } {
    return this.createPwdForm.controls;
  }


  //  Here we are verifying the link clicked from email
  getVerifyLinkforEmailSignup() {
    try {
      let data = {
        "link": this.link
      }
      this._service.postService(this._service.API_URL.getVerifyLinkforEmailSignup, data).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.getEmail = response?.data?.email;
          this.getName = response?.data?.name;
          this.verifiedId = response?.data?.id;
        } else {
          this.verifyEmailErrorMessage = response.status.message;
          this.getLimitandLink = response.status.msgCode;
          this.commonService.getLimit.next(this.getLimitandLink);
          if (this.verifyEmailErrorMessage && this.getLimitandLink === 'LIMIT_EXCEEDS' || this.verifyEmailErrorMessage && this.getLimitandLink === 'URL_EXPIRED') {
            this._router.navigateByUrl('link-expired');
          }
        }
      })
    } catch (error) {

    }
  }


  //  Here we signing up clicking on  Add Button
  onSignUp() {
    try {
      this.createNewPasswordFromLinkDto.id = this.verifiedId
      this.createNewPasswordFromLinkDto.password = this.encrypt.encrypt(this.createPwdForm.controls['password'].value)
      this.createNewPasswordFromLinkDto.confirmPassword = this.encrypt.encrypt(this.createPwdForm.controls['confirmPassword'].value)
      this.createNewPasswordFromLinkDto.acceptTerms = this.createPwdForm.controls['acceptTerms'].value
      this._service.postService(this._service.API_URL.signupAssignedUrl, this.createNewPasswordFromLinkDto).subscribe((response: any) => {
        if (response.status.code === 200) {
          this.isProducyKeyVerified = false;
          this.emailVerified = false;
          $("#signupSuccess").modal("show")
          this.createPwdForm.reset();
        } else {
          this.erroMessage = response.status.message;
        }

      })
    }
    catch (e) {
      console.log(e);
    }
  }



  // Checking the password when clicking on eye icon
  onClick(val: string) {
    if (val == 'pwd') {
      if (this.password === 'password') {
        this.password = CommonEnums.text;
        this.newPassword = true;
      } else {
        this.password = CommonEnums.password;
        this.newPassword = false;
      }
    } else if (val == 'confPwd') {
      if (this.passwords === 'password') {
        this.passwords = CommonEnums.text;
        this.confPassword = true;
      } else {
        this.passwords = CommonEnums.password;
        this.confPassword = false;
      }
    }
  }


  //  Verifying the product key 
  verifyProductKey(key: any) {
    try {
      if (this.createPwdForm.controls['productKey'].value?.length > 15) {
        let data = {
          productKey: this.createPwdForm.controls['productKey'].value
        }
        this._service.postService(this._service.API_URL.verifyProductKey, data).subscribe((response: any) => {
          if (response.status.code === 200) {
            this.isProducyKeyVerified = true;
          }
          else {
            this.isProducyKeyVerified = false;
            this._toastr.error('', response.status.message);
          }

        })
      }
    }
    catch (e) { }
  }


  onFocusOut() {
    if (this.createPwdForm.controls['password'].value !== this.createPwdForm.controls['confirmPassword'].value) {
      this.pwdNotMatch = true;
    }
    else {
      this.pwdNotMatch = false;
    }

  }

  passwordVerify() {
    if (this.createPwdForm.controls['confirmPassword'].value?.length != 0 && this.createPwdForm.controls['password'].value !==
      this.createPwdForm.controls['confirmPassword'].value) {
      this.pwdNotMatch = true;
    } else {
      this.pwdNotMatch = false;
    }
  }

  goToLogin() {
    $("#signupSuccess").modal("hide")
    this._router.navigate(['/'])
  }

  getLanguageMap: { [key: string]: string } = {
    ENGLISH: 'en',
    SPANISH: 'es',
    ITALIAN: 'it'
  };
}
